import { Activity } from "../activities/Activity";

export function ActivityToGpxString(activity: Activity): string
{
    let xmlHeader = '<?xml version="1.0" encoding="UTF-8"?>';
    let xmlNameSpaces = 'xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"'
            + ' xsi:schemaLocation="http://www.topografix.com/GPX/1/1' 
                + ' http://www.topografix.com/GPX/1/1/gpx.xsd' 
                + ' http://www.garmin.com/xmlschemas/GpxExtensions/v3'
                + ' http://www.garmin.com/xmlschemas/GpxExtensionsv3.xsd'
                + ' http://www.garmin.com/xmlschemas/TrackPointExtension/v1'
                + ' http://www.garmin.com/xmlschemas/TrackPointExtensionv1.xsd"'
            + ' xmlns="http://www.topografix.com/GPX/1/1"'
            + ' xmlns:gpxtpx="http://www.garmin.com/xmlschemas/TrackPointExtension/v1"'
            + ' xmlns:gpxx="http://www.garmin.com/xmlschemas/GpxExtensions/v3"';

    let xmlGpxStart = `<gpx creator="Pedal Breath Repeat" version="1.1" ${xmlNameSpaces}>`;
    let xmlGpxContent = BuildGpxContent(activity);
    let xmlGpxEnd = '</gpx>';
    let xml = `${xmlHeader}\n${xmlGpxStart}\n${xmlGpxContent}\n${xmlGpxEnd}`;

    return xml;
}

function BuildGpxContent(activity: Activity): string
{
    let result = BuildMetadata(activity) + BuildTrack(activity);
    return result;
}

function BuildMetadata(activity: Activity): string
{
    const time = activity.StartTime.toISOString();
    return ` <metadata>\n  <time>${time}</time>\n </metadata>\n`
}

function BuildTrack(activity: Activity): string
{
    let result = "";
    result += " <trk>\n"
    result += "  <name>PBR Virtual Ride</name>\n";
    result += "  <type>VirtualRide</type>\n";

    for (let i = 0; i < activity.Intervals.length; i++)
    {
        var interval = activity.Intervals[i];

        result += "  <trkseg>\n";

        for (let r = 0; r < interval.Records.length; r++)
        {
            var record = interval.Records[r];
            result += `   <trkpt lat="${record.Latitude}" lon="${record.Longitude}">\n`;

            result += `    <ele>${record.Elevation}</ele>\n`
            result += `    <time>${record.Time.toISOString()}</time>\n`;

            if (record.Power != null || record.HeartRate != null || record.Cadence != null)
            {
                result += `    <extensions>\n`
                if (record.Power != null)
                    result += `     <power>${record.Power}</power>\n`
                if (record.HeartRate != null || record.Cadence != null)
                {
                    result += `     <gpxtpx:TrackPointExtension>\n`;
                    if (record.HeartRate != null)
                        result += `      <gpxtpx:hr>${record.HeartRate}</gpxtpx:hr>\n`;
                    if (record.Cadence != null)
                        result += `      <gpxtpx:cad>${record.Cadence}</gpxtpx:cad>\n`;

                    result += `     </gpxtpx:TrackPointExtension>\n`;
                }
                result += `    </extensions>\n`
            }

            result += '   </trkpt>\n';
        }

        result += "  </trkseg>\n";
    }

    result += " </trk>\n"

    return result;
}